module.exports = " <div class=\"md-padding breadcrumb\"> <ul class=\"list-unstyled d-flex m5 ng-cloak\"> <li class=\"breadcrumb-item home\"><a ui-sref=home.home><md-icon class=material-icons> home </md-icon></a></li> <li class=\"breadcrumb-item active\">Términos y condiciones</li> </ul> </div> <md-content class=\"ml15 mr15\" layout=column> <advertisement sh-ctrl=$ctrl.shCtrl type-content=espacios positions=1 page-name=PAG-16></advertisement> </md-content> ";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/shared/components/static-views/views/terms-adaptative.html
 ** module id = 902
 ** module chunks = 7
 **/